const L = {
  name: "BackspaceFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.60427 4.19492C6.16883 3.45207 7.0505 3 8.00043 3L21.0004 3C22.6527 3 24.0004 4.34772 24.0004 6L24.0004 18C24.0004 19.6523 22.6527 21 21.0004 21L8.00043 21C7.0505 21 6.16883 20.5479 5.60427 19.8051L5.60041 19.8L1.10043 13.8L1.09908 13.7982C0.304214 12.7334 0.304214 11.2666 1.09908 10.2018L1.10043 10.2L5.60427 4.19492ZM19.4146 9L18.0004 7.58579L15.0004 10.5858L12.0004 7.58579L10.5862 9L13.5862 12L10.5862 15L12.0004 16.4142L15.0004 13.4142L18.0004 16.4142L19.4146 15L16.4146 12L19.4146 9Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as BackspaceFilled
};
